var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.042 2C6.51899 2 2.04199 6.477 2.04199 12C2.04199 17.523 6.51899 22 12.042 22C17.565 22 22.042 17.523 22.042 12C22.042 6.477 17.564 2 12.042 2ZM11.292 17.75L6.29199 14L7.79199 12L10.792 14.25L16.042 7.25L18.042 8.75L11.292 17.75Z",
    fill: "#57C880"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-circle-2.0acd71d6b892beaa25627a50ec272116.svg";